import {
    call,
    select,
    take,
    put
} from 'redux-saga/effects';
import {
    REQUEST_FACETED_ITEMS,
    requestFacetedItems
} from '../actions/facetActions';

import {
    beginRequestSaga
} from './categoryInitialSagas';

import {
    getCurrentCategory,
    getCustomPriceRangeQueryString
} from '../utils/utils';

import { handleUtagEvent } from '../../../core/js/actions/initialActions';

import {
    createCustomPriceGAEvent
} from '../utils/customPriceRangeUtils';

/**
 * Get list of products based on selected facets
 * @returns {undefined} Returns undefined
 */
export function* facetSaga() {
    let action = {};

    // eslint-disable-next-line no-cond-assign
    while (action = yield take(REQUEST_FACETED_ITEMS)) {
        const state = yield select();
        const requestedPage = 1;

        yield call(
            beginRequestSaga,
            requestedPage,
            action.payload.requestType,
            state.category.categorySlug,
            state.category.searchTerm,
            action.payload.queryString,
            action.payload.pushState,
            action.meta
        );
    }
}

export function* submitCustomPriceForm(store, event, component, context = null) {
    const state = yield select();
    const currentQueryString = _.get(state, 'category.queryString', '');
    const newQueryString = getCustomPriceRangeQueryString(state.category);
    const categoryId = getCurrentCategory();

    // if the queryString hasnt changed, do nothing
    if (currentQueryString === newQueryString) {
        return;
    }

    const gaEvent = createCustomPriceGAEvent(state);
    yield put(handleUtagEvent(gaEvent, 'link'));
    yield put(requestFacetedItems(categoryId, '', '', false, newQueryString, true, event, component, context));
}

export default [
    facetSaga
];
